export const LOCALES = {
  ENGLISH: "en-Ca",
  FRENCH: "fr-Ca",
};
